import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { googleLogin, register } from '../../actions/userActions';
import Default from '../../assets/default.png';
import './Register.css'
import { useGoogleLogin } from '@react-oauth/google';
import { useFormik } from "formik";
import { basicSchema } from '../helpers/basicSchema';
import DefaultLogo from '../../assets/smilelogo.png';
import GoogleSignInButton from '../../assets/btn_google_signin_dark_normal.png';
import ReactGA from 'react-ga4';

const Register = () => {

    const [avatar, setAvatar] = useState('');
    const [avatarPreview, setAvatarPreview] = useState(Default);

    const dispatch = useDispatch();
    const location = useLocation();

    const { user, error, loading } = useSelector(state => state.auth);

    let navigate = useNavigate();

    useEffect(() => {

        if(user?.roleId === 1) {
            navigate("/groups", { replace: true });
        }

    }, [dispatch, user]);

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: (location.pathname + location.search), title: "Register" });
    }, [location]);

    const onSubmit = async (values, actions) => {
        const formData = new FormData();
        formData.set('firstName', values.firstName);
        formData.set('lastName', values.lastName);
        formData.set('username', values.username);
        formData.set('email', values.email);
        formData.set('password', values.password);
        formData.set('avatar', avatar);
        formData.set('roleId', 1);
        dispatch(register(formData));
    };

    const { values, errors, touched, isSubmitting, handleBlur, handleChange, handleSubmit, } = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            username: "",
            email: "",
            password: "",
            confirmPassword: "",
        },
        validationSchema: basicSchema,
        onSubmit,
    });

    const onChange = e => {
        if(e.target.name === 'avatar') {
          const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    setAvatarPreview(reader.result)
                }
            }
            reader.readAsDataURL(e.target.files[0])
            setAvatar(e.target.files[0])
        } 
    };

    function handleGoogleLoginSuccess(tokenResponse) {

        const accessToken = tokenResponse.access_token;

        dispatch(googleLogin(accessToken))
    };

    const glogin = useGoogleLogin({onSuccess: handleGoogleLoginSuccess});

  return (
    <div className='min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8'>
        <Link to="/" className='registerheader'>
            <img src={DefaultLogo} className="w-12" alt='Smile logo' />
        </Link>
        <div className='flex items-center justify-center w-full max-w-xl bg-gray-200 border border-gray-200 rounded m-auto py-8 px-4'>
            <div className='registerblock sm:flex-row flex-col'>
                <div className='registermain md:w-[450px]'>
                    <div className='heading w-full sm:flex-row flex-col'>
                        <h1 className='headingsign'>Sign up</h1>
                        <p className='headingleft'>Already have an account?<Link to={"/login"} className='span'> Sign in</Link></p>
                    </div>
                    <div className='registerscreen md:flex-row flex-col w-full'>
                        <div className='profilediv'>
                            <div className='profileimg' style={{ 
                                backgroundImage: `url(${avatarPreview})`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat'
                                }}>
                            </div>
                            <input type="file" id="avatar" name="avatar" onChange={onChange} accept='image/*' required className="cursor-pointer" />
                            <label htmlFor="avatar" className='cursor-pointer uploadinfo'>Upload profile picture</label>
                        </div>
                        
                        <div className='formelements w-full'>
                            <form onSubmit={handleSubmit} encType='multipart/form-data' className='w-full'>
                                {error?<p className='errormsg'>{error}</p>:null}
                                <label htmlFor="firstName" className='fnamelabel asterisk_input'>First name:</label>
                                <input type="text" id="firstName" name="firstName" value={values.firstName} onChange={handleChange} onBlur={handleBlur} className={"w-full"} />
                                {errors.firstName && touched.firstName && <p className="text-xs text-red-700">{errors.firstName}</p>}
                                <label htmlFor="lastName">Last name:</label>
                                <input type="text" id="lastName" name="lastName" value={values.lastName} onChange={handleChange} onBlur={handleBlur} className={"w-full"} />
                                {errors.lastName && touched.lastName && <p className="text-xs text-red-700">{errors.lastName}</p>}
                                <label htmlFor="username" className='asterisk_input'>Username:</label>
                                <input type="text" id="username" name="username" value={values.username} onChange={handleChange} onBlur={handleBlur} className={"w-full"} />
                                {errors.username && touched.username && <p className="text-xs text-red-700">{errors.username}</p>}
                                <label htmlFor="lname" className='asterisk_input'>Email:</label>
                                <input type="email" id="email" name="email" value={values.email} onChange={handleChange} onBlur={handleBlur} className={"w-full"} />
                                {errors.email && touched.email && <p className="text-xs text-red-700">{errors.email}</p>}
                                <label htmlFor="password" className='asterisk_input'>Password:</label>
                                <input type="password" id="password" name="password" value={values.password} onChange={handleChange} onBlur={handleBlur} className={"w-full"} />
                                {errors.password && touched.password && (<p className="text-xs text-red-700">{errors.password}</p>)}
                                <label htmlFor="confirmpassword">Confirm Password:</label>
                                <input type="password" name="confirmPassword" id="confirmPassword" value={values.confirmPassword} onChange={handleChange} onBlur={handleBlur} className={"w-full"} />
                                {errors.confirmPassword && touched.confirmPassword && (<p className="text-xs text-red-700">{errors.confirmPassword}</p>)}
                                <button type='submit' className='w-full px-4 py-2 my-5 text-center rounded-md shadow text-white bg-[#8C1515] hover:bg-gray-800' disabled={isSubmitting}>
                                {loading ? 
                                    <>
                                    <svg role="status" className="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                    </svg> Sign up for free
                                    </>: 'Sign up for free'}
                                </button>
                            </form>

                            {(process.env.REACT_APP_ENABLE_GOOGLESIGNIN === "true") && <>
                            <div className="relative flex items-center justify-center w-full mt-4 border border-t">
                                <div className="absolute px-5 mb-5 logindivider">OR</div>
                            </div>
                            <button type="button" onClick={() => glogin()} className="my-4">
                                <img className="h-16 cursor-pointer" src={GoogleSignInButton} alt="
                                Sign in with Google button" />
                            </button>
                            </>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Register